import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from './Sidebar';
import TopNavbar from '../top-navbar/TopNav';
import '../../styles/employee/add-attachment.css';
import { toast } from 'react-toastify';
import { FaTimes } from 'react-icons/fa';
import { getAttachments, saveAttachment } from '../../services/employee/api';

const Attachment = ({ candidateId, employmentInfos, onBack }) => {
    const [files, setFiles] = useState([]); // line 8
    const [uploadedUrls, setUploadedUrls] = useState([]); // line 9
    const [remarks, setRemarks] = useState(''); // line 10
    const [isVerified, setIsVerified] = useState(false); // line 11
    const [isSubmitting, setIsSubmitting] = useState(false); // line 12

    const token = localStorage.getItem('bgc_token'); // line 14

    // Fetch existing attachments on page load
    const fetchAttachments = async () => {
    try {
        const response = await getAttachments(candidateId);

        const data = Array.isArray(response.data) ? response.data : [];

        const initialFiles = Array(employmentInfos.length).fill(null);
        const initialUrls = Array(employmentInfos.length).fill(null);

        employmentInfos.forEach((info, index) => {
        const existing = data.find(
            (att) => att.employeeCode === info.employeeCode
        );
        if (existing) {
            initialUrls[index] = existing.filename || null;
            if (existing.remarks) setRemarks(existing.remarks);
            if (existing.isVerified === "COMPLETED") setIsVerified(true);
        }
        });

        setFiles(initialFiles);
        setUploadedUrls(initialUrls);
    } catch (err) {
        const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Failed to load existing attachments.";

        toast.error(errorMessage);
    }
    };

    useEffect(() => {
        fetchAttachments();
    }, [candidateId]);

    // Handle new file selection
    const handleFileChange = (e, index) => {
        const file = e.target.files[0];
        const updatedFiles = [...files];
        updatedFiles[index] = file;
        setFiles(updatedFiles);

        // FIX: Immediately show uploaded file as link
        const updatedUrls = [...uploadedUrls];
        updatedUrls[index] = file ? URL.createObjectURL(file) : null; // line 61
        setUploadedUrls(updatedUrls);
    };

    const removeAttachmentFile = (index) => {
        const updatedFiles = [...files];
        updatedFiles[index] = null;
        setFiles(updatedFiles);
        const updatedUrls = [...uploadedUrls];
        updatedUrls[index] = null;
        setUploadedUrls(updatedUrls);
    };

    // Validation
    const validateForm = () => {
       
        const hasAnyFile = files.some(f => f !== null) || uploadedUrls.some(url => url !== null);
        if (!hasAnyFile) {
            toast.error('At least one proof must be uploaded.');
            return false;
        }
        
         if (!remarks.trim()) {
            toast.error('Remarks are mandatory.');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setIsSubmitting(true);

        try {
            const formData = new FormData();
            formData.append("isVerified", isVerified);
            formData.append("remarks", remarks);

            employmentInfos.forEach((info, index) => {
                if (files[index]) {
                    formData.append("files", files[index]);
                    formData.append("companyNames", info.companyName);
                    formData.append("employeeCodes", info.employeeCode);
                } else if (uploadedUrls[index]) {
                    // Send empty blob to preserve mapping for already uploaded files
                    formData.append("files", new Blob(), info.employeeCode);
                    formData.append("companyNames", info.companyName);
                    formData.append("employeeCodes", info.employeeCode);
                }
            });

            try {
                const response = await saveAttachment(candidateId, formData);
                toast.success("Attachments saved successfully!", {
                    autoClose: 3000,
                });
                onBack();
            } catch (error) {
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to save attachments.";

                toast.error(errorMessage, {
                    autoClose: 3000,
                });
            }

        } catch (err) {
            console.error('Error submitting attachments:', err);
            toast.error('Failed to submit attachments. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="dashboard-app-container">
            <Sidebar />
            <div className="dashboard-right-panel">
                <TopNavbar />
                <header className="attachment-header-bar">
                    <h2 className="attachment-header-title">Add Verification Proof</h2>
                </header>
                <div className="attachment-container">
                    <div className="attachment-form-container">
                        <form onSubmit={handleSubmit}>
                            <div className="attachment-file-uploads-section">
                                {employmentInfos.map((info, index) => (
                                    <div key={info.id} className="attachment-file-upload-card">
                                        <h3 className="attachment-upload-section-title">
                                            {info.companyName} Proof
                                        </h3>
                                        <div className="attachment-file-input-group">
                                            <label className="attachment-choose-file-button" htmlFor={`attachment-file-input-${index}`}>
                                                Drag & Drop or Click to Upload
                                            </label>
                                            <input
                                                id={`attachment-file-input-${index}`}
                                                type="file"
                                                onChange={(e) => handleFileChange(e, index)}
                                                className="attachment-hidden-file-input"
                                            />

                                            {(files[index] || uploadedUrls[index]) && (
                                                <div className="file-list">
                                                    <span className="file-list-item">
                                                        {files[index] ? files[index].name : uploadedUrls[index].split('/').pop()}
                                                        <FaTimes className="remove-file-icon" onClick={() => removeAttachmentFile(index)} />
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <small className="attachment-file-size-info">
                                            * File must be PDF / JPG / PNG and less than 5MB
                                        </small>
                                    </div>
                                ))}
                            </div>

                            <div className="attachment-common-details-card">
                                <label className="attachment-remarks-label">Remarks</label>
                                <textarea
                                    className="attachment-remarks-textarea"
                                    placeholder="Type here..."
                                    value={remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                ></textarea>

                                <div className="attachment-verification-status-group">
                                    <label className="attachment-checkbox-label">
                                        <input
                                            type="checkbox"
                                            checked={isVerified}
                                            onChange={(e) => setIsVerified(e.target.checked)}
                                            className="attachment-verification-checkbox"
                                        />
                                        Verification Status
                                    </label>
                                      <p className="verification-note">
                                            ⚠️ Once verified, this step will be locked and you cannot return to modify the virtual employment details.
                                      </p>
                                </div>
                            </div>

                            <div className="attachment-button-group">
                                <button type="button" className="attachment-cancel-button" onClick={onBack}>
                                    Cancel
                                </button>
                                <button type="submit" className="attachment-submit-button" disabled={isSubmitting}>
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Attachment;
